﻿import {  useEffect, useState } from 'react';

// lib 
import { motion, AnimatePresence } from 'framer-motion';

// components
import Label from './Label'
import OptionButton from './OptionButton'
import OptionRadio from './OptionRadio'
import RadioSubQuestion from './RadioSubQuestion';


const Option = ({
    option,
    id,
    subQuestionGroup,
    handleAnswer,
    setCurrentAnswer,
    togglesSubQuestion,
    handleNext,
    ...props
}) => {

    const [showSubQuestion, setShowSubQuestion] = useState(false)
    const [answer, setAnswer] = useState('')
    const [subQId, setSubQId] = useState(0)

    const updateAnswer = (event, subQuestionId, togglesSubQuestion) => {
        if (!showSubQuestion) {
            setShowSubQuestion(true)
            handleAnswer(event.target.value, id, togglesSubQuestion)
        }

        if (showSubQuestion) {
            setAnswer(event.target.value)
            setSubQId(subQuestionId)
        }
    }

    const postAnswer = () => {
        handleAnswer(answer, subQId, false)
        setCurrentAnswer(answer)
        handleNext()
    }

    return (
        <>
            {togglesSubQuestion === false && (
                <>
                    {option.text === "Ja" || option.text === "Nej" ?
                        <OptionButton
                            togglesSubQuestion={false}
                            className="pension-wizard-block__question__card__options__option__button"
                            text={option.text}
                            id={id}
                            handleAnswer={handleAnswer}
                        />
                        :
                        <OptionRadio
                            togglesSubQuestion={false}
                            className="pension-wizard-block__question__card__options__option__radio"
                            text={option.text}
                            id={id}
                            handleAnswer={handleAnswer}
                        />
                    }
                </>
            )}

            {togglesSubQuestion === true && (
                <div key={option.text}>
                    <div>
                        <input
                            className="pension-wizard-block__question__card__options__option__radio__input"
                            type='radio'
                            name="Answer"
                            id="QuestionId"
                            value={option.text}
                            onChange={(event) => updateAnswer(event, null, togglesSubQuestion)}
                        />
                        <Label
                            className="pension-wizard-block__question__card__options__option__radio"
                            key={option.text}
                            for='QuestionId'>
                            <span className="pension-wizard-block__question__card__options__option__text">{option.text}</span>
                        </Label>
                    </div>
                </div>
            )}
   
            {showSubQuestion && subQuestionGroup.questions && subQuestionGroup.questions.map((q, index) => (
                <RadioSubQuestion
                    q={q}
                    postAnswer={postAnswer}
                    updateAnswer={updateAnswer}
                    key={index}
                    text={q.questionText}
                    id={q.id}
                    className="pension-wizard-block__question__card__options__option__subquestion"
                    buttonText="Nästa"
                />
            ))}
        </>
     )
}

export default Option;

